var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreadcrumbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M3.25622 13.9355H5.85395L6.27038 15.172H8.065L5.54659 8.172H3.58342L1.065 15.172H2.83979L3.25622 13.9355ZM4.55509 10.0566L5.41769 12.6193H3.7024L4.55509 10.0566Z",
    fill: "#0973F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M15 5L9 17.4L15 5Z",
    fill: "#00AEEE",
    stroke: "#00AEEE",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5536 11.5823C21.9893 11.6687 22.3393 11.8698 22.6036 12.1855C22.8679 12.5013 23 12.8619 23 13.2674C23 13.8524 22.7804 14.3161 22.3411 14.6585C21.9018 15.0008 21.2893 15.172 20.5036 15.172H17V8.172H20.3857C21.15 8.172 21.7482 8.33487 22.1804 8.6606C22.6125 8.98634 22.8286 9.42841 22.8286 9.98681C22.8286 10.399 22.7125 10.7413 22.4804 11.0139C22.2482 11.2864 21.9393 11.4759 21.5536 11.5823ZM18.8321 11.0039H20.0321C20.3321 11.0039 20.5625 10.9424 20.7232 10.8194C20.8839 10.6965 20.9643 10.5153 20.9643 10.276C20.9643 10.0367 20.8839 9.85386 20.7232 9.72755C20.5625 9.60125 20.3321 9.53809 20.0321 9.53809H18.8321V11.0039ZM20.8946 13.6015C20.7268 13.7311 20.4893 13.7959 20.1821 13.7959H18.8321V12.2503H20.1607C20.4679 12.2503 20.7089 12.3201 20.8839 12.4597C21.0589 12.5993 21.1464 12.7921 21.1464 13.0381C21.1464 13.2841 21.0625 13.4719 20.8946 13.6015Z",
    fill: "#00AEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbs);
export default __webpack_public_path__ + "static/media/breadcrumbs.5a495790.svg";
export { ForwardRef as ReactComponent };